import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '@app/main/admin/admin.service';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-toolbar-report',
    templateUrl: './admin-toolbar-report.component.html',
    styleUrls: ['./admin-toolbar-report.component.scss'],
    standalone: false
})
export class AdminToolbarReportComponent extends AdminActionsDirective {
    searchValue: string;

    constructor(adminService: AdminService, dialogService: DialogService, moduleService: ModuleService) {
        super(adminService, dialogService, moduleService);
    }
}
